import { Injectable } from '@angular/core';
import { UtilitiesService } from '../utilities/utilities.service';
import { CartService } from './cart.service';

declare var window: any;
@Injectable({
    providedIn: 'root',
})
export class AppiceHomeWirelessService {

    constructor(
        private UTS: UtilitiesService,
        private CS: CartService,
    ) { }



    hwPageLoadEvent(screenName: string){
        try{
            var object = {};
            object['name'] = 'Screen_Name';
            object['properties'] = {
                ScreenName: screenName,
                user_env: (this.UTS.getENV()) ? this.UTS.getENV() : 'Web',
                UserType: this.getUserType()
            }
            
            this.clickEvent(object);
        }catch(e){
        }
    }

    hwModifyCartEvent(screenName: string, eventName: string){
        try{
            var object = {};
            object['name'] = eventName;
            var products = [];
            this.CS.getCart().subscribe((cart: any) => {
                if(cart.numberOfItemsInCart > 0){
                    cart.items.forEach(item => {
                        if(item.productName.includes('Home Wireless')){
                            products.push(this.objectManagment(screenName, item));
                        }
                        else{
                            products.push(this.objectManagment(screenName, item));
                        }
                    })
                }
            })
            object['properties'] = products;
            this.clickEvent(object);
        } catch(e){
        }
    }

    hwPromoCodeEvent(screenName, promoCodeApplied, error = null){
        var internetType =  this.getPlanName() === 'Home Wireless 4G'  ? '4G': this.getPlanName() == 'Home Wireless 5G' ? '5G' : 'Home Wireless';
        try{
            var object = {};
            object['name'] = promoCodeApplied ? 'PromoCode_Success': 'PromoCode_Error';
            object['properties'] = {
                ScreenName: screenName,
                user_env: this.UTS.getENV(),
                UserType: this.getUserType(),
                Category: 'Home Wireless',
                SubCategory: internetType,
                PromoCodeApplied: promoCodeApplied
            }
            if(error != null && error != ''){
                object['properties']['Error'] = error;
            }
            this.clickEvent(object);
        } catch(e){
        }
    }
    getPlanName(){
        return sessionStorage.getItem('planName');
    }

    getUserType(){
        var isLoggedIn = sessionStorage.getItem('isLoggedIn');
        if(isLoggedIn != null){
            return isLoggedIn == 'true' ? 'LoggedIn': 'Guest';
        }
        return 'Guest';
    }

    clickEvent(object) {
        try {
            if (window.Appice) {
                window.Appice.recordEvent({
                    key: object.name,
                    segment: object.properties
                });
            }
        } catch (e) {
        }
    }


    getCategory() {
        var catName = '';//$location.search()['category'];
        // if(catName== undefined ){
        if (localStorage.getItem('category') && localStorage.getItem('category') != "undefined") {
            catName = localStorage.getItem('category');
        }
        // }

        return catName;
    };

    getCategoryName() {
        var catName = '';// $location.search()['catName'] || "";

        if (localStorage.getItem('catName') && localStorage.getItem('catName') != "undefined") {
            catName = JSON.parse(localStorage.getItem('catName'));
        }
        else if (sessionStorage.getItem('listVal') && sessionStorage.getItem('listVal') != "undefined") {
            catName = JSON.parse(sessionStorage.getItem('listVal'));
        }


        return catName;
    };

    getSubCategory() {
        var catName = '';// $location.search()['subCategory'];
        // if(catName== undefined ){
        if (localStorage.getItem('subCategory') && localStorage.getItem('subCategory') != "undefined") {
            catName = localStorage.getItem('subCategory');
        }
        // }

        return catName;
    }


    passAllProductsToCart(screenName, eventName, item) {
        try {
            const payload = {
                name: (eventName) ? eventName : '',
                properties: {}
            }
            this.objectManagment(screenName, item).then(res => {
                payload.properties = res
                this.clickEvent(payload);
            })

        } catch (e) {
        }
    }

    onError(screenName, errorName, error, userInfo) {
        try {
            var object = {};
            object['name'] = errorName;
            object['properties'] = {

                'ScreenName': screenName,
                'user_env': this.UTS.getENV(),
                'UserType': userInfo.userType ? userInfo.userType : 'guest',
                'Error': error

            }
            this.UTS.log(object);
            this.clickEvent(object);
        } catch (e) {
        }
    }

    objectManagment(screenName, item:any) {
        let payload = {};
        return new Promise((resolve, reject) => {
            this.CS.getProductDetails(item).subscribe((result:any) => {
                if(item.displayName.includes('Home Wireless')){
                    var internetType =  this.getPlanName() === 'Home Wireless 4G'  ? '4G': this.getPlanName() == 'Home Wireless 5G' ? '5G' : 'Home Wireless';
                    let sku = result ? result.planSkus && result.planSkus.length > 0 ? result.planSkus[0] : null : null;
                    payload = {
                        'ScreenName': (screenName) ? screenName : '',
                        'user_env': (this.UTS.getENV()) ? this.UTS.getENV() : 'web',
                        'UserType': this.getUserType(),
                        'Category': 'Home Wireless',
                        'SubCategory': internetType,
                        'SubCategoryID': internetType,
                        'ProductID': (result && result.productId) ? result.productId : '',
                        'skuID': (sku && sku.skuId) ? sku.skuId : '',
                        'DisplayName': (result && result.productName) ? result.productName : '',
                        'DisplayNameAr': (result && result.productNameAr) ? result.productNameAr : (result && result.parentDisplayNameAr) ? result.parentDisplayNameAr : '',
                        'DeepLink': window.location.href,
                        'PaymentAmount': sku ? sku.recurringPrice : '',
                        'PaymentTerm': result ? result.allowOneTimePayment ? 'OneTime': 'Months': '',
                        'isWirelessRouter':  internetType == '5G' ? true : JSON.parse(localStorage.getItem('isWirelessRouter'))
                    }
                }
                else{
                    payload = {
                        'ScreenName': (screenName) ? screenName : '',
                        'user_env': (this.UTS.getENV()) ? this.UTS.getENV() : 'web',
                        'UserType': this.getUserType(),
                        'Category': (item && item.commerceItemCategory) ? item.commerceItemCategory : '',
                        'SubCategory': this.getCategoryName(),
                        'SubCategoryID': this.getSubCategory(),
                        'ProductID': (item && item.productId) ? item.productId : '',
                        'skuID': (item && item.skuId) ? item.skuId : '',
                        'DisplayName': (item && item.displayName) ? item.displayName : '',
                        'DisplayNameAr': (item && item.displayNameAr) ? item.displayNameAr : (item && item.parentDisplayNameAr) ? item.parentDisplayNameAr : '',
                        'DeepLink': window.location.href,
                        'PaymentAmount': (item && item.paymentOptions && item.paymentOptions.priceIncVAT) ? item.paymentOptions.priceIncVAT : '',
                        'InStock': true,
                    }
                }
                resolve(payload);
            })
            
        })
        
    }



}
